import normalizeJsonApi from '../../shared/utilities/jsonApiNormalizer';

import { Agent, AgentFromAPI, AgentJSONAPIResponse, SerializedAgent } from './types';

const agentSerializer = (agent: AgentFromAPI): Agent => ({
    id: agent.id,
    ...agent.attributes,
});

export const serializeAgentFromAPI = (json: AgentJSONAPIResponse): SerializedAgent => {
    const { agent: agents } = normalizeJsonApi<{
        agent: { [key: string]: AgentFromAPI };
    }>(json);
    return {
        agent: agents
            ? Object.fromEntries(
                  Object.entries(agents).map(([key, value]) => [key, agentSerializer(value)]),
              )
            : {},
    };
};
